<template>
  <div class="policy-page">
    <header class="policy-header">
      <router-link class="brand" to="/">
        <span class="brand-mark" aria-hidden="true">
          <span></span>
        </span>
        <span>
          <strong>Codex API</strong>
          <em>codex API 中转服务</em>
        </span>
      </router-link>
      <div class="policy-actions">
        <router-link to="/register">返回注册</router-link>
        <router-link to="/login">登录</router-link>
      </div>
    </header>

    <main class="policy-shell">
      <section class="policy-card">
        <p class="policy-kicker">Codex API 协议中心</p>
        <h1>{{ currentPolicy.title }}</h1>
        <p class="policy-summary">{{ currentPolicy.summary }}</p>

        <div class="policy-list">
          <article v-for="item in currentPolicy.sections" :key="item.title">
            <h2>{{ item.title }}</h2>
            <p>{{ item.text }}</p>
          </article>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
const terms = {
  title: '服务条款',
  summary: '这里模拟展示 Codex API 服务使用规则、账号责任和服务变更说明。',
  sections: [
    {
      title: '账号与使用',
      text: '用户需要保证账号信息真实可用，并对账号下产生的接口调用、密钥使用和团队成员操作负责。'
    },
    {
      title: '服务可用性',
      text: '平台会尽力保持服务稳定，但模拟页面不承诺真实 SLA，正式版本应接入后端状态监控和告警。'
    },
    {
      title: '费用与额度',
      text: '额度、用量和账单信息以控制台展示为准，后续可扩展为真实数据库和支付系统记录。'
    }
  ]
};

export default {
  name: 'PolicyView',
  computed: {
    currentPolicy() {
      return terms;
    }
  }
};
</script>
